import React from 'react';
import {
  BASE_CHOWNOW_URL,
  BASE_SUPPORT_URL,
  TERMS_URL,
  PRIVACY_URL,
  CCPA_URL,
} from '@chownow/cn-web-utils/paths';

import OutLink from 'components/shared/OutLink/OutLink';
import IconSocialInstagram from '../SVG/IconSocialInstagram';
import IconSocialFacebook from '../SVG/IconSocialFacebook';
import IconSocialTwitter from '../SVG/IconSocialTwitter';

import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <footer className={styles.footer} data-testid="Footer">
      <div className={styles.footerContent}>
        <div className={styles.textOutlinks}>
          <OutLink ariaLabel="About Us" to={`${BASE_CHOWNOW_URL}/about`}>
            About Us
          </OutLink>
          <OutLink ariaLabel="Help" to={`${BASE_SUPPORT_URL}/customer/s/`}>
            Help
          </OutLink>
          <OutLink ariaLabel="Terms of Use" to={TERMS_URL}>
            Terms of Use
          </OutLink>
          <OutLink ariaLabel="Privacy Policy" to={PRIVACY_URL}>
            Privacy Policy
          </OutLink>
          <OutLink ariaLabel="Do Not Sell or Share My Personal Information" to={CCPA_URL}>
            Do Not Sell or Share My Personal Information
          </OutLink>
          <OutLink ariaLabel="Limit The Use Of My Sensitive Personal Information" to={CCPA_URL}>
            Limit The Use Of My Sensitive Personal Information
          </OutLink>
        </div>
        <div className={styles.socialLinks}>
          <OutLink ariaLabel="Instagram" to="https://instagram.com/ChowNow/">
            <IconSocialInstagram />
          </OutLink>
          <OutLink ariaLabel="Twitter" to="https://twitter.com/ChowNow/">
            <IconSocialTwitter />
          </OutLink>
          <OutLink ariaLabel="Facebook" to="https://facebook.com/ChowNow/">
            <IconSocialFacebook />
          </OutLink>
        </div>
      </div>
    </footer>
  );
}
